import { inject, Injectable, signal } from '@angular/core';
import { EditorSelection, SelectionType } from 'guideline/domain';

import { CommentService } from '@treetop/shared/comments';
import { GuidelineHeader } from '@treetop/shared/model';

@Injectable()
export class SelectionService {
  private commentsService = inject(CommentService, { optional: true });

  private _selection = signal<EditorSelection | undefined>(undefined);
  public selection = this._selection.asReadonly();

  public selectFlowchartElement(widgetId: string, uniqueId: string): void {
    this._selection.set({ type: SelectionType.Flowchart, widgetId, uniqueId });

    this.commentsService?.selectCommentByFlowchartElementId(uniqueId);
  }

  public selectEditorHeader(object: GuidelineHeader): void {
    this._selection.set({ type: SelectionType.EditorHeader, element: object });
  }

  public selectWidget(widgetId: string): void {
    this._selection.set({ type: SelectionType.Widget, widgetId });
  }

  public clearSelection(): void {
    this._selection.set(undefined);
  }
}
